module.exports = __webpack_public_path__ + "static/media/a132.52855001.jpg";